import React, { Component } from 'react'
import { NavLink} from 'react-router-dom'

export default class Address extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="address">
                    <div className="container">
                        <div className="cont">
                            <form action="">
                                <h6>DELIVERY ADDRESS</h6>
                                <input name='name' required type="text" onChange={this.props.onChange} placeholder='Enter Your Name' />
                                <input name='email' required type="email" onChange={this.props.onChange} placeholder='Enter Your Email' />
                                <input name='Governorate' required type="text" onChange={this.props.onChange} placeholder='Enter Governorate' />
                                <input name='country' required type="text" onChange={this.props.onChange} placeholder='Enter City' />
                                <input name='city' required  type="text" onChange={this.props.onChange} placeholder='Enter Town' />
                                <input name='code' required  type="text" onChange={this.props.onChange} placeholder='Enter Postal Code' />
                                {this.props.info.name !== " " && this.props.info.Governorate !== " " && this.props.info.city !== " " && this.props.info.code !== " " && this.props.info.country !== " " && (
                                    <NavLink to='/pay' ><button>CONTINUE</button></NavLink>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
